import { useEffect, useState } from "react";
import { IoCloudOfflineOutline } from "react-icons/io5";

// A persistent, app-wide heads-up when the device has no connection at all —
// distinct from a slow-but-connected request, which individual actions
// report for themselves via utils/errors.js's friendlyError().
export default function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    function goOnline() {
      setOnline(true);
    }
    function goOffline() {
      setOnline(false);
    }

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div style={banner}>
      <IoCloudOfflineOutline style={{ verticalAlign: -2, marginRight: 6 }} />
      You're offline — some things may not load until you're back online.
    </div>
  );
}

// Deliberately NOT position:fixed — this renders before <Navbar/> in App.js,
// and Navbar's own top bar is position:sticky at top:0. Two fixed elements
// both pinned to top:0 (this used to be one of them, alongside
// UpdateBanner.jsx) just draw on top of each other instead of stacking,
// which was hiding the logo/bell/search strip behind this banner entirely
// whenever it showed. As a normal flow element it pushes that sticky bar
// down by its own real height instead, so nothing gets covered no matter
// how tall the text wraps to, and works right even if UpdateBanner is
// showing too.
const banner = {
  background: "#D8534A",
  color: "#FFF8F0",
  textAlign: "center",
  fontSize: 12.5,
  fontWeight: 600,
  padding: "8px 12px",
};
